/**
 * Constants used in the App
 *  (ie: endpoints, images, ...)
 */

export const endpoints = {
    // API Endpoints
    // data: ``,
};

export const basePath = '__basePath__';

export const buildVersion = '__buildVersion__';

export const buildDate = '__buildDate__';
